<template>
	<div class="content text-white">
		<div class="flex justify-center items-center mb-8">
			<img src="@/assets/img/InAppbannerROG_JFXGOLDX.png" class="banner-promo">
		</div>

		<div class="flex justify-center items-center">
			<div class="promo-content">
				<div class="text-1.5xl font-bold mb-5">Deskripsi Program</div>

				<div class="text-sm">
					<div class="mb-5">
						Program Instant Return on Gold adalah program yang berlaku bagi peserta yang melakukan transaksi pembelian
						emas fisik melalui platform JFXGOLD X atau pengguna aplikasi yang terhubung diantaranya yaitu METALGO+,
						NUNOMICS, Pospay Gold dan BMT Digi, peserta akan mendapatkan Instant Return senilai 1% dari nilai yang
						ditransaksikan.
					</div>

					<div class="font-bold">
						Periode Program
					</div>
					<div class="mb-5">
						<Loader v-if="!periodeProgram" size_prop="1rem" borderSize_prop="0.3rem"></Loader>
						<div v-else>
							{{ periodeProgram }}
						</div>
					</div>

					<div class="font-bold">
						Penawaran Program
					</div>
					<div class="mb-5">
						Instant Return on Gold sebesar 1% dari setiap nominal transaksi pembelian emas fisik JFXGOLD X
					</div>

					<div class="font-bold">
						Skema Return
					</div>
					<div class="mb-5">
						Instant ROG akan ditransfer ke rekening RDK (Rekening Dana Komoditi) milik pengguna secara real time setelah
						transaksi pembelian berhasil dilakukan
					</div>

					<div class="font-bold">
						Kuantitas transaksi
					</div>
					<div class="mb-5">
						Tidak ada batasan minimal dan maksimal untuk kuantitas transaksi pembelian
					</div>

					<div class="font-bold">
						Fleksibilitas Jual dan Beli
					</div>
					<div class="mb-5">
						Gramasi emas yang ada dapat dijual kapan saja dan tidak ada ketentuan Lock dana
					</div>

				</div>

				<div class="text-1.5xl font-bold mb-5">Syarat & Ketentuan</div>

				<div class="text-sm">
					<ol>
						<li class="mb-2">
							Peserta program adalah seluruh pengguna yang tercatat melakukan transaksi dari periode program
							berlangsung (Peserta program bersifat otomatis tanpa ada proses registrasi).
						</li>

						<li class="mb-2">
							Peserta program bertransaksi melakukan pembelian emas fisik melalui platform JFXGOLD X atau aplikasi
							METALGO+/NUNOMICS/POSPAY GOLD/BMT DIGI.
						</li>

						<li class="mb-2">
							Tidak ada batasan layanan pembelian emas fisik
						</li>

						<li class="mb-2">
							Setiap pembelian emas fisik (tanpa batas minimal dan maksimal) yang berhasil dilakukan berhak
							mendapatkan Instant Return on Gold (ROG) senilai 1%
						</li>

						<li class="mb-2">
							Mengikuti kisaran gramasi dan harga emas fisik yang telah ditentukan di dalam Bursa Berjangka
							berdasarkan harga perdagangan internasional.
						</li>

						<li class="mb-2">
							Pembayaran tepat waktu adalah wajib, dengan pembayaran yang sesuai dengan layanan emas fisik yang
							ditransaksikan.
						</li>

						<li class="mb-2">
							Transfer Instant Return on Gold (ROG) dilakukan secara real time setelah proses transaksi berhasil
							dilakukan oleh peserta.
						</li>

						<li class="mb-2">
							Peserta dapat mengajak rekan lain untuk mengikuti program dengan membuka akun Peserta Emas Digital
							melalui kode promotor masing-masing.
						</li>

						<li class="mb-2">
							Instant Return on Gold (ROG) berlaku selama periode program berlangsung.
						</li>

						<li class="mb-2">
							Instant Return on Gold (ROG) hanya berlaku bagi transaksi beli emas fisik dan tidak berlaku bagi
							transaksi jual emas fisik.
						</li>

						<li class="mb-2">
							Apabila posisi order pembelian langsung fill (secara sistem) Instant Return on Gold (ROG) akan
							ditransfer ke rekening RDK milik pengguna secara real time setelah status transaksi pembelian dan
							penjualan match atau pembelian berhasil dilakukan.
						</li>

						<li class="mb-2">
							Apabila posisi order bersifat partial fill, maka Instant Return on Gold (ROG) tidak akan diterima oleh
							H+2 hari kerja dari
							semenjak posisi transaksi Settle.
						</li>

						<li class="mb-2">
							Saldo Instant Return on Gold (ROG) masuk ke dalam rekening RDK Peserta.
						</li>
					</ol>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import { EVENT_KEYS } from '../../internal/events'
import Loader from '../../components/Loader.vue';

export default {
	name: 'Promo',

	components: {
		Loader
	},

	computed: {
		EVENT_KEYS() {
			return EVENT_KEYS
		},

		periodeProgram() {
			// 2027-02-25T12:10:07.000Z
			const startDate = this.$store.getters['events/getEventStartDate'](EVENT_KEYS.rog)
			const endDate = this.$store.getters['events/getEventEndDate'](EVENT_KEYS.rog)

			if (!startDate || !endDate) return null

			// format: 27 Maret 2025 - 31 Januari 2026
			const startDateFormatted = new Date(startDate).toLocaleDateString('id-ID', { month: 'long', day: 'numeric', year: 'numeric' })
			const endDateFormatted = new Date(endDate).toLocaleDateString('id-ID', { month: 'long', day: 'numeric', year: 'numeric' })

			return startDateFormatted + ' - ' + endDateFormatted
		}
	},

	created() {
		// fetch ROG event detail
		if (this.$store.getters.paymentMethod == 'rped') {
			this.$store.dispatch('events/fetchEvent', EVENT_KEYS.rog)
		}
	}
}
</script>

<style>
.promo-content {
	width: 52.5rem;
}

.banner-promo {
	max-width: 118.75rem;
	width: 100%;
}
</style>